var React = require('react');

function TagInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 11.8594C0 12.4688 0.234375 13.0312 0.65625 13.4531L10.5469 23.3438C11.4375 24.2344 12.8906 24.2344 13.7344 23.3438L23.2969 13.7812C24.1875 12.9375 24.1875 11.4844 23.2969 10.5938L13.4062 0.703125C12.9844 0.28125 12.4219 0 11.8125 0H2.25C0.984375 0 0 1.03125 0 2.25V11.8594ZM5.25 3C6.46875 3 7.5 4.03125 7.5 5.25C7.5 6.51562 6.46875 7.5 5.25 7.5C3.98438 7.5 3 6.51562 3 5.25C3 4.03125 3.98438 3 5.25 3Z","fill":"white"}));
}

TagInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = TagInline;

TagInline.default = TagInline;
